export default __webpack_public_path__ + "static/media/mountEverest.f78dfab7.jpeg";